<div *ngIf="show.report" id="pdfPointTransferContent"></div>
<div class="ui-g">

    <div class="ui-g-12" *ngIf="show.datatable">
      <app-kontable title="{{ 'loyalty.point_transfer' | translate }}"
                    [columns]="[
                    'card_no_src',
                    'card_no_dest',
                    { field: 'transDate', bodyTemplate: dayValid, title: 'reportTransferPoint.transferDate' },
                    'customerHostSrc',
                    'customerHostDest',
                    'acmDescription',
                    'value',
                    'reason_dest',
                    'reason_src'
                    ]"
                    [titles]="[
                    fields.cardSource,
                    fields.cardDestination,
                   
                    fields.customerHostSrc,
                    fields.customerHostDest,
                    fields.accumulator,
                    fields.value,
                    fields.causalePlus,
                    fields.causaleMinus
                    ]"
                    [service]="srvPointTransfer"
                    [paginationType]="serverPagination"
                    [showInfoButton]="false"
                    [showRecoverButton]="false"
                    [showEditButton]="false"
                    [showGlobalFilter]="false"
                    [showDetailsButton]="false"
                    [showAddButton]="true"
                    [showDeleteButton]="false"
                    [toolbarCustomButtons]="customButton"
                    [(fireNewDataAvailable)]="newDataAvailable"
                    [additionalRowCommands]="customRowCommands"
                    (onAdd)="onClickAdd()"
                    (onRemove)="remove($event)">

                    <ng-template #dayValid data-testid="dayValid" let-row>
                      {{ formatDate(row.transDate) }}
                  </ng-template>

                    <ng-template #customRowCommands data-testid="customRowCommands" let-row>
                      <p-button pTooltip="{{ 'reportTransferPoint.button_export' | translate }}" label="" icon="fa fas fa-file" styleClass="ui-button-info" (onClick)="onClickReport(row)"></p-button>
                    </ng-template>

      </app-kontable>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-point-transfer/loyalty-point-transfer.component.html